import type { Locale } from "../../content/types"
import { privacyContent } from "../../content/privacy"

interface PrivacyPageProps {
  locale: Locale
}

export default function PrivacyPage({ locale }: PrivacyPageProps) {
  const t = privacyContent

  return (
    <div className="max-w-4xl mx-auto px-4 py-16 md:py-24">
      <h1 className="text-4xl md:text-5xl font-bold text-text-primary mb-12">{t.title[locale]}</h1>

      <div className="prose prose-lg max-w-none text-text-secondary leading-relaxed space-y-12">
        <p className="text-xl font-medium text-text-primary/80">{t.intro[locale]}</p>

        <section className="bg-site-bg-alt p-8 rounded-card border border-border-subtle">
          <h2 className="text-2xl font-bold text-text-primary mb-4">{t.contactBlock.title[locale]}</h2>
          <div className="space-y-4 not-prose">
            <p>
              <a
                href={t.contactBlock.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-button-primary hover:underline font-semibold text-lg"
              >
                {t.contactBlock.websiteUrl}
              </a>
            </p>
            <div className="text-text-secondary space-y-1">
              <p>{t.contactBlock.address[locale]}</p>
              <p>{t.contactBlock.phone}</p>
            </div>
            <p className="pt-4 text-sm italic border-t border-border-subtle">{t.contactBlock.officer[locale]}</p>
          </div>
        </section>

        {t.sections.map((section) => (
          <section key={section.title[locale]}>
            <h2 className="text-2xl font-bold text-text-primary mb-6 border-b border-border-subtle pb-2">
              {section.title[locale]}
            </h2>

            {section.paragraphs?.map((paragraphGroup, i) => (
              <div key={i} className="space-y-4">
                {paragraphGroup[locale].map((paragraph, j) => (
                  <p key={j}>{paragraph}</p>
                ))}
              </div>
            ))}

            {section.list && (
              <ul className="list-none space-y-3 mt-6">
                {section.list[locale].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className={`w-2 h-2 rounded-full bg-button-primary ${section.paragraphs ? "mt-2" : ""}`}></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            )}

            {section.highlight && (
              <div className="mt-6 bg-button-primary/5 border border-button-primary/10 p-4 rounded-xl inline-block">
                <p className="font-bold text-button-primary">
                  {section.highlight.label[locale]}: {section.highlight.value[locale]}
                </p>
              </div>
            )}

            {section.complaint && (
              <div className="mt-6 pt-6 border-t border-border-subtle">
                <p className="text-sm text-text-muted mb-4 uppercase tracking-wider font-bold">
                  {section.complaint.title[locale]}
                </p>
                <p>{section.complaint.body[locale]}</p>
              </div>
            )}
          </section>
        ))}
      </div>
    </div>
  )
}
